<script lang="ts">
import { defineComponent, reactive, computed } from 'vue'
import PrDocumentCardBanners from '@/components/banner/PrDocumentCardBanners.vue'
import RankingWeeklyForAside from '@/components/contents/RankingWeeklyForAside.vue'
import SignUpCta from '@/components/cta/SignUpCta.vue'
import stateInitializer from '@/models/stateInitializer'
import { useUserStore } from '@/stores/user'
import { useClientStore } from '@/stores/client'

export default defineComponent({
  name: 'KeywordsAsideSecondary',

  components: {
    PrDocumentCardBanners,
    RankingWeeklyForAside,
    SignUpCta,
  },

  setup() {
    // store
    const userStore = useUserStore()
    const clientStore = useClientStore()

    interface State {
      prSolutionContents: SolutionContentItem[],
    }
    const state: State = reactive({
      prSolutionContents: [],
    })
    stateInitializer(state, 'asideSecondary')

    const ctaParameters = computed(() => {
      return [
        { name: 'trcd', value: `${clientStore.trackingCodePrefix}_signup_keywords_right_column` },
      ]
    })

    return {
      // store
      userStore,

      // data
      state,

      // computed
      ctaParameters,
    }
  },
})
</script>

<template>
  <section class="section">
    <PrDocumentCardBanners :items="state.prSolutionContents" />
    <SignUpCta
      v-if="!userStore.context.isSignedIn"
      variant="b"
      :parameters="ctaParameters" />
    <RankingWeeklyForAside
      type="keyword"
      :limit="10"
      is-show-on-empty />
  </section>
</template>
